export default __webpack_public_path__ + "static/media/Parking - Grey.f8b81226.svg";